<template>
  <div class="">
    <h1>{{ msg }}</h1>
    <!-- 使用方式一，在模板字符串中使用 -->
    <h1>使用方式一：</h1>
    <h4>{{ $t("msg.msg1") }}</h4>

    <!-- 使用方式二，绑定属性使用 -->
    <h1>使用方式二：</h1>
    <h4 v-text="$t('msg.msg2')"></h4>
    <el-input :placeholder="$t('msg.msg2')"></el-input>

    <h1>使用方式四：存在多个值之间的切换</h1>
    <h4>{{ $t(`msg.${msgss}`) }}</h4>
    <button @click="changeWord">切换按钮</button>
    <el-select
      v-model="languageValue"
      @change="changeLanguage"
      placeholder="请选择"
    >
      <el-option
        v-for="item in languageOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      msgss: "message",
      languageValue: "",
      languageOptions: [],
    };
  },
  created() {
    //最开始请求的时候看缓存是什么状态
    if (this.$i18n.locale == "zh") {
      this.languageValue = "中文简体";
      this.languageOptions = [{ value: "en", label: "English" }];
    } else {
      this.languageValue = "English";
      this.languageOptions = [{ value: "zh", label: "中文简体" }];
    }
  },
  methods: {
    getI18n() {
      console.log(this.$t("msg.msg1"));
    },
    changeWord() {
      if (this.msgss === "message") {
        this.msgss = "display";
      } else {
        this.msgss = "message";
      }
    },
    // 多语言切换
    changeLanguage(type) {
      console.log(type);
      // 此处做了语言选择记录，存在localStorage中，这里的作用只有一个当我重新请求页面
      //的时候先取localStorage的记录值
      localStorage.setItem("locale", type);
      this.$i18n.locale = type; // 修改页面需要显示的语言
      if (this.$i18n.locale == "zh") {
        this.languageValue = "中文简体";
        this.languageOptions = [{ value: "en", label: "English" }];
      } else {
        this.languageValue = "English";
        this.languageOptions = [{ value: "zh", label: "中文简体" }];
      }
    },
  },
  mounted() {
    this.getI18n();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
